import {useQuery, useMutation} from '@apollo/client'
import {Spinner} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {GET_SYSTEM_EMAIL_SETTINGS} from '../../../gql/queries/emailSettingsQuery'
import {SEND_TEST_EMAIL, UPDATE_SYSTEM_EMAIL_SETTINGS} from '../../../gql/mutations/emailSettingsMutations'
import {EmailSetupForm, IEmailSetupValues} from '../../shared/EmailSetupForm'

export const EmailSetupTab = () => {
  const {data, loading, refetch} = useQuery(GET_SYSTEM_EMAIL_SETTINGS, {fetchPolicy: 'network-only'})
  const [updateSystemEmailSettings, {loading: saving}] = useMutation(UPDATE_SYSTEM_EMAIL_SETTINGS)
  const [sendTestEmail, {loading: sendingTestEmail}] = useMutation(SEND_TEST_EMAIL)

  const settings = data?.systemEmailSettings

  const handleSave = async (input: IEmailSetupValues) => {
    const {publicRequireIdentity, ...rest} = input
    try {
      const res = await updateSystemEmailSettings({variables: {input: rest, publicRequireIdentity}})
      const result = res.data?.updateSystemEmailSettings
      if (!result?.success) {
        toast.error(result?.errors?.map((e: any) => e.message).join('\n') || 'Error saving Email Setup')
        return
      }
      toast.success('Email Setup saved')
      refetch()
    } catch (err: any) {
      toast.error(err.message || 'Error saving Email Setup')
    }
  }

  const handleSendTestEmail = async (toEmail: string) => {
    try {
      const res = await sendTestEmail({variables: {toEmail}})
      const result = res.data?.sendTestEmail
      if (!result?.success) {
        toast.error(result?.errors?.map((e: any) => e.message).join('\n') || 'Error sending test email')
        return
      }
      toast.success(`Test email sent to ${toEmail}`)
    } catch (err: any) {
      toast.error(err.message || 'Error sending test email')
    }
  }

  if (loading) {
    return (
      <div className='text-center py-6'>
        <Spinner animation='border' size='sm' />
      </div>
    )
  }

  return (
    <div>
      <p className='text-muted mb-4' style={{fontSize: '0.85rem'}}>
        SMTP transport and system default values (equivalent to the EMAIL_* variables in .env).
        An organization can override these values from its own Email Setup tab.
      </p>
      <EmailSetupForm
        values={settings}
        showInheritance={false}
        showPublicRequireIdentity
        publicRequireIdentity={settings?.publicRequireIdentity}
        saving={saving}
        onSave={handleSave}
        onSendTestEmail={handleSendTestEmail}
        sendingTestEmail={sendingTestEmail}
      />
    </div>
  )
}
